<script>
import UserResource from '@/resources/user'
import messages from '@/mixins/messages'

export default {
    mixins: [messages],
    data() {
        return {
            newPassword: '',
            newPasswordConfirm: '',
        }
    },
    props: {
        userResource: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async onSubmit() {
            try {
                let user = await this.userResource.setPassword(this.newPassword)
                this.$emit('success', user)
            } catch (e) {
                if (e && e.response && e.response.data['non_field_errors']) {
                    this.addMessage('danger', e.response.data['non_field_errors'].join('.'))
                } else if (e.response && e.response.status == 400) {
                    this.addMessage('danger', 'Login failed, please check your login details and try again')
                } else {
                    this.addMessage('danger', e.message || 'An unexpected error occurred, please reload this page and try again')
                    throw e
                }
            }
        },
        isValid() {
            return this.newPassword && this.newPassword === this.newPasswordConfirm
        },
    },
}
</script>

<template>
    <b-form class="horizontal" @submit.prevent="onSubmit">
        <b-form-group label="New Password:">
            <b-form-input type="password" name="password" v-model="newPassword" autocomplete="new-password" />
        </b-form-group>
        <b-form-group label="New Password (again):">
            <b-form-input type="password" name="passwordConfirm" v-model="newPasswordConfirm" autocomplete="new-password" />
        </b-form-group>
        <messages :to="messages" />
        <slot name="footer">
            <b-button type="submit" :disabled="!isValid()">Submit</b-button>
        </slot>
    </b-form>
</template>
